/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { RootStateOrAny, useSelector } from "react-redux";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";
import { AuthState } from "../../../store/ducks/auth/types";

interface IOportunidadeLeadPost {
  idLead: string | undefined;
  numeroCotacao?: string | null | undefined;
  numeroFicha?: string | null | undefined;
  onSuccess: Function;
  anexo?: string | null | undefined;
  cpfLead?: string | null | undefined;
  codigoTipoEmpresaVendas?: string | number;
}

// Variáveis opcionais passadas em mutate() têm prioridade sobre os props,
// garantindo que o valor mais atual (ex: numeroCotacao) seja enviado mesmo
// que a request dispare antes do re-render carregar o novo estado.
interface IOportunidadeLeadPostVariables {
  numeroCotacao?: string | null | undefined;
  numeroFicha?: string | null | undefined;
  cpfLead?: string | null | undefined;
}

export function useOportunidadeLeadPost(props: IOportunidadeLeadPost) {
  const { idAD, codigoEmpresaVendas365 } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const postData = async (
    variables?: IOportunidadeLeadPostVariables | void
  ) => {
    const CADASTRAR_OPORTUNIDADE_LEAD = `${backofficeEnviroment}/common/oportunidades-lead/v1`;
    const { data } = await instance.post(CADASTRAR_OPORTUNIDADE_LEAD, {
      idLead: props.idLead,
      numeroCotacao: variables?.numeroCotacao ?? props.numeroCotacao,
      numeroFicha: variables?.numeroFicha ?? props.numeroFicha,
      idAdCorretor: idAD,
      anexo: props?.anexo,
      cpfLead: variables?.cpfLead ?? props?.cpfLead,
      codigoTipoEmpresaVendas: codigoEmpresaVendas365
        ? parseInt(codigoEmpresaVendas365, 10)
        : "",
    });
    return data;
  };

  const mutation = useMutation<any, any, IOportunidadeLeadPostVariables | void>(
    postData,
    {
      onSuccess: () => {
        toast.success("Oportunidade cadastrada com sucesso");
        props.onSuccess();
      },
      onError: (error: any) => {
        toast.error(
          `Erro ao cadastrar oportunidade. Motivos: ${error.response.data.notifications.map(
            (item: any) => item?.message
          )} `,
          { autoClose: 10000 }
        );
      },
    }
  );

  return mutation;
}
